import { css } from '@compiled/react';
import { FormattedMessage, useIntl } from 'react-intl';

import { JoinableSites } from '@/components/signup/site-activation/components/common/joinable-sites';
import { ReturnToProduct } from '@/components/signup/site-activation/components/common/return-to-product';
import { SiteActivation } from '@/components/signup/site-activation/site-activation';
import {
	useFirstName,
	useIsConfluenceContactCompanyExpandEligible,
} from '@/components/user-context/helpers/cohorts';

export const LoggedInForm = () => {
	const intl = useIntl();

	const firstName = useFirstName();

	const useContactExpandCohortLogic = useIsConfluenceContactCompanyExpandEligible();

	if (useContactExpandCohortLogic) {
		return (
			<div css={containerStyles}>
				<h1 css={[headerStyles, headerContactExpandCss]}>
					<FormattedMessage
						id="BxpUiSignup.nameSite.header"
						defaultMessage="Welcome back, {name}"
						values={{ name: firstName }}
					/>
				</h1>
				<SiteActivation
					useContactExpandCohortLogic={true}
					CurrentProductJoinableUser={<JoinableSites />}
					CurrentProductUser={<ReturnToProduct />}
				/>
			</div>
		);
	}

	const headerText = intl.formatMessage(
		{
			id: 'BxpUiSignup.nameSite.header',
			defaultMessage: 'Welcome back, {name}',
		},
		{
			name: firstName,
		},
	);

	return (
		<div css={containerStyles}>
			<h1 css={headerStyles}>{headerText}</h1>
			<SiteActivation WeekOneUser={null} />
		</div>
	);
};

const containerStyles = css({
	background: 'white',
	borderRadius: '20px',
	padding: '40px 50px 56px',
	width: '468px',
});

const headerStyles = css({
	fontWeight: 500,
});

const headerContactExpandCss = css({
	margin: '0 0 1rem',
	textAlign: 'center',
});
